var _path, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAmericanExpress(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    x: "0px",
    y: "0px",
    viewBox: "0 0 56 35",
    style: {
      enableBackground: "new 0 0 56 35"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M52,0H4C1.8,0,0,1.8,0,4v27c0,2.2,1.8,4,4,4h48c2.2,0,4-1.8,4-4V4C56,1.8,54.2,0,52,0z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#F4F9FC",
    d: "M52,35H4c-2.2,0-4-1.8-4-4V4c0-2.2,1.8-4,4-4h48c2.2,0,4,1.8,4,4v27C56,33.2,54.2,35,52,35z M4,1 C2.3,1,1,2.3,1,4v27c0,1.7,1.3,3,3,3h48c1.7,0,3-1.3,3-3V4c0-1.7-1.3-3-3-3H4z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#4CAADE",
    d: "M7.9,12L2,24h7l0.9-1.9h2l0.9,1.9h7.7v-1.5l0.7,1.5h4l0.7-1.5V24H42l2-1.9l1.8,1.9l8.3,0l-5.9-6 l5.8-6h-8.1l-1.9,1.8L42.2,12H24.7l-1.5,3.1L21.6,12h-7v1.4L13.8,12H7.9z M9.2,13.7h3.4l3.9,8.1v-8.1h3.7l3,5.8l2.8-5.8h3.7v8.6 h-2.3v-6.7l-3.3,6.7h-2l-3.3-6.7v6.7h-4.7l-0.9-1.9H8.5l-0.9,1.9H5.1L9.2,13.7z M31.9,13.7h9.2l2.8,2.8l2.9-2.8h2.8L45.4,18l4.3,4.3 h-3l-2.8-2.9l-2.9,2.9h-9.1V13.7z M10.9,15.2l-1.6,3.4h3.2L10.9,15.2z M34.1,15.5v1.6h5v1.7h-5v1.7h5.6l2.6-2.5l-2.5-2.5H34.1z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAmericanExpress);
export default __webpack_public_path__ + "static/media/american_express.aac08312.svg";
export { ForwardRef as ReactComponent };